import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
})
export class LoginPageComponent {
  userdata?: UserData;

  validsession: boolean | undefined;

  currentYear: number = new Date().getFullYear();

  constructor(
    private sesssionvalidator: SessionvalidateService,
    private router: Router
  ) {
    this.checkLogin();
  }

  checkLogin() {
    this.validsession = this.sesssionvalidator.validate();
    if (this.validsession) {
      this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
      this.router.navigate(['/menu']);
    }
  }
}
